export const apiDomain = "https://ospv2.kndi.institute/"
export const apiDomain2 = "https://journal.kndi.institute/"
//export const apiDomain = "http://localhost:8000/"
export const grant_writing_needs_assessment_Url =
  apiDomain + "api/atri/grant-writing-needs-assessment"
export const grant_writing_training_Url =
  apiDomain + "api/atri/grant-writing-training"
export const stkPushArticleUrl = apiDomain + "api/atri/"
export const stkPushQueryArticleUrl = apiDomain + "api/atri/"
export const jndArticleUrl = apiDomain2 + "issues/check_parse_pull_article.php"
export const jndArticleAssessmentUploadUrl =
  apiDomain2 + "issues/add_conference_2023_article_reviewer.php"
export const jndArticleAssessmentReviewersUrl =
  apiDomain2 + "issues/all_conference_2023_article_reviews.php"
export const jndArticleAssessmentReviewUrl =
  apiDomain2 + "issues/review_conference_2023_article.php"
export const jndArticleAssessmentReviewOneUrl =
  apiDomain2 + "issues/one_review_conference_2023_article.php"
export const jndArticleAssessmentExportUrl =
  apiDomain2 + "issues/export_all_confrence_2023_article_reviews.php"
export const jndArticleAssessmentResendUrl =
  apiDomain2 + "issues/all_conference_2023_article_reviews_resend.php"
export const jndArticleAssessmentEditOneUrl =
  apiDomain2 + "issues/one_review_conference_2023_article_edit.php"
export const jndArticleAssessmentEditUrl =
  apiDomain2 + "issues/all_conference_2023_article_reviews_edit.php"
export const getHeader = function() {
  const tokenData = window.$cookies.get("authUser")
  const headers = {
    Accept: "application/json",
    Authorization: "Bearer " + tokenData.access_token
  }
  return headers
}

export const getHeaderVisitor = function() {
  const headers = {
    Accept: "application/json"
  }
  return headers
}



// WEBPACK FOOTER //
// ./src/config.js